import { instance, API_PATHS } from '.'

export const getSingleUser = (userId) => {
  return instance.get(`${API_PATHS.datahubPath}/users/${userId}`).then((res) => res.data)
}

export const updateSingleUser = (userId, payload) => {
  return instance.patch(`${API_PATHS.datahubPath}/users/${userId}`, payload)
}

export const getUserProfile = () => {
  return  instance.get(`${API_PATHS.mainPath}/user-profile-service/userprofile`)
}

export const addReferralCode = (payload) => {
  return instance.post(`${API_PATHS.mainPath}/user-profile-service/add-referralcode`,payload)
}

export const updateUserPassword = (payload) => {
  return instance.put(`${API_PATHS.mainPath}/user-profile-service/userprofile/change_password`, payload)
}